import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        evaluationGroup: '=',
        forms: '=',
        company: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'evaluation.Edit general data' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form ng-submit="vm.save()" class="form">
                <form-wrapper form="vm.form">
                    <evaluation-form form="vm.form" forms="vm.forms" company="vm.company" />
                    <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
                </form-wrapper>
            </form>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, FormFactory, MomentService, ModalService) {
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.MomentService = MomentService;
        this.ModalService = ModalService;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.evaluationGroup, {
            expand: 'form,completedEvaluationCount,notCompletedEvaluationCount,activeI18n,evaluationGroupI18ns'
        });
        this.oldDeadline = this.MomentService.formatTimeStamp(this.evaluationGroup.deadline, 'YYYY-MM-DD HH:mm:ss', true);
    }

    showConfirmationWindow () {
        if (this.oldDeadline === this.form.model.deadline) {
            return false;
        }
        return this.form.model.notCompletedEvaluationCount;
    }

    save () {
        if (this.showConfirmationWindow()) {
            const message = this.$translate.instant('evaluation.deadline_confirmation_message', {
                deadline: this.MomentService.format(this.form.model.deadline)
            });
            this.ModalService.confirm(message, 'medium').then(() => this.doSave());
        }
        else {
            this.doSave();
        }
    }

    doSave () {
        this.form.save().then(updatedGroup => this.uibModalInstance.close(updatedGroup));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/evaluation/edit/index.js